import Model from "../Model";

class Grouptops extends Model{

    buildUrl ({ param }) {
        return ['/groupview/top', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Grouptops;